import { useHTTPClient } from "helper";
import { applyBulkReportChanges } from "./bulkReportChanges";

const ReportsService = () => {
  const { get, post, put, del, postDoc } = useHTTPClient();

  const getReports = (id) => get(`Documents/Download?ProjectShortGuid=${id}`);

  const getXhtml = (id) => get(`Documents/DownloadWithAdditionalData?ProjectShortGuid=${id}`);

  const getReport = () => get("Mappings");

  const createReport = (data, config) => post(`Reports`, data, config);

  const getProjects = (companyId) => get(`Dropdowns/CompanyProjects?CompanyShortGuid=${companyId}`);

  const getProjectReports = (projectId) =>
    get(`Dropdowns/ProjectReports?ProjectShortGuid=${projectId}`);

  const getReportMappings = (reportId) => get(`Reports/GetAllMappings/${reportId}`);

  const saveReportMappings = (data) => put(`Reports/UpdateMappings`, data);

  const deleteReport = (body, config) => del("Reports", body, config);

  const getAllReports = (shortGuid) => get(`Reports/GetAll/${shortGuid}`);

  const uploadExcel = (file, sheetIndex, config, sourceToken) =>
    postDoc(`Reports/UploadExcel?sheetIndex=${sheetIndex}`, file, config, sourceToken);

  const checkTablesInHtml = (projectShortGuid) =>
    get(`Reports/CheckTablesInHtml?ProjectShortGuid=${projectShortGuid}`);

  const getExcelTable = (body) => post("Reports/GetExcelTable", body);

  const bulkReportChanges = (params) =>
    applyBulkReportChanges({
      ...params,
      createReport,
      deleteReport,
    });

  return {
    getReports,
    getXhtml,
    getReport,
    createReport,
    getProjects,
    getProjectReports,
    getReportMappings,
    saveReportMappings,
    deleteReport,
    getAllReports,
    uploadExcel,
    checkTablesInHtml,
    getExcelTable,
    bulkReportChanges,
  };
};

export default ReportsService;
